var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('module-container',_vm._l((_vm.questions),function(answerItem,answerIndex){return _c('div',{key:answerItem.questionId},[_c('answer-item',{attrs:{"answer":answerItem,"index":answerIndex}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }